import * as React from 'react';
import { debounce } from 'lodash';

import MediaObject from 'components/MediaObject';
import Token from 'components/Token';
import Tokenizer from 'components/Tokenizer';
import DeprecatedTypeahead from 'components/DeprecatedTypeahead';
import { KeyboardEventHandler } from 'types/typescript/eventHandlers';
import { TokenItem } from 'components/Tokenizer';

type Props = {
  prompt?: string;
  placeholder?: string;
  /* (optional) button to the right of the tokenizer */
  actionButton?: React.ReactElement;
  autoFocus?: boolean;
  onInputChange?: (text: string) => void;
  className?: string;
} & DefaultProps;

type DefaultProps = {
  value: Array<TokenItem>;
  tokenRenderer?: (item: any) => any;
  onChange?: (items: any[]) => void;
};

class DeprecatedTokenizerTypeahead extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    value: [],
    tokenRenderer: (datum) => <Token>{datum}</Token>,
    onChange: (_data) => {},
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.value !== this.props.value) {
      (this.refs.typeahead as any).updateResults();
    }
  }

  handleSelect = (datum: TokenItem) => {
    const { tokenizer } = this.refs;
    const { value } = this.props;
    const index = value.indexOf(datum);
    if (index >= 0) {
      (tokenizer as any).remove(datum);
    } else {
      (tokenizer as any).add(datum);
    }
    (tokenizer as any).clearInputValue();
    (tokenizer as any).focusInput();
  };
  handleSelectAll = (data: TokenItem[]) => {
    const { tokenizer } = this.refs;
    (tokenizer as any).add(data);
    (tokenizer as any).focusInput();
  };
  handleInputChange = (query: string) => {
    if (this.props.onInputChange) {
      this.props.onInputChange(query);
    }
    this.setTypeaheadQuery(query);
  };

  // HACK around using refs within render
  setTypeaheadQuery = debounce((query: string) => {
    if (this.refs.typeahead) {
      (this.refs.typeahead as any).setQuery(query);
    }
  }, 200);

  // HACK around using refs within render
  handleInputKeyDown: KeyboardEventHandler = (event) => {
    if (this.refs.typeahead) {
      (this.refs.typeahead as any).handleKeyDown(event);
    }
  };
  render() {
    const {
      value,
      prompt,
      placeholder,
      tokenRenderer,
      autoFocus,
      onChange,
      actionButton,
      ...props
    } = this.props;

    const tokenizer = (
      <Tokenizer
        ref="tokenizer"
        value={value}
        prompt={prompt}
        placeholder={placeholder}
        tokenRenderer={tokenRenderer}
        autoFocus={autoFocus}
        onChange={onChange}
        onInputChange={this.handleInputChange}
        onInputKeyDown={this.handleInputKeyDown}
      />
    );

    const controlRow = actionButton ? (
      <MediaObject figure="right" gutter="xsmall" center>
        {tokenizer}
        {actionButton}
      </MediaObject>
    ) : (
      tokenizer
    );

    return (
      <DeprecatedTypeahead
        {...props}
        ref="typeahead"
        className={props.className}
        onSelect={this.handleSelect}
        onSelectAll={this.handleSelectAll}
      >
        {controlRow}
      </DeprecatedTypeahead>
    );
  }
}

export default DeprecatedTokenizerTypeahead;
